module.exports = __webpack_public_path__ + "img/낙성대 고기집.314123be.png";